export const globalStyle = {
  // Layout
  container: "w-full min-h-screen bg-black",
  page: "w-full min-h-screen px-4 md:px-6 lg:px-8 py-4 md:py-6 lg:py-8 bg-black",

  // Typography
  h1: "text-3xl md:text-4xl lg:text-5xl font-bold text-white",
  h2: "text-2xl md:text-3xl lg:text-4xl font-semibold text-white",
  h3: "text-xl md:text-2xl lg:text-3xl font-semibold text-white",
  h4: "text-lg md:text-xl lg:text-2xl font-semibold text-white",
  h5: "text-base md:text-lg lg:text-xl font-semibold text-white",
  h6: "text-sm md:text-base lg:text-lg font-semibold text-white",

  body1: "text-base md:text-lg text-gray-300 leading-relaxed",
  body2: "text-sm md:text-base text-gray-400 leading-relaxed",
  caption: "text-xs md:text-sm text-gray-500",

  // Buttons
  btn: "inline-flex items-center justify-center rounded-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed",
  btnPrimary:
    "bg-primary text-black hover:bg-primary-600 focus:ring-primary shadow-light",
  btnSecondary:
    "bg-black text-primary border border-primary hover:bg-gray-900 focus:ring-primary shadow-light",
  btnTertiary:
    "bg-gray-800 text-gray-300 hover:bg-gray-700 focus:ring-gray-600",
  btnDanger:
    "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 shadow-light",
  btnSuccess:
    "bg-green-600 text-white hover:bg-green-700 focus:ring-green-500 shadow-light",

  btnSize: {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2.5 text-base",
    lg: "px-6 py-3 text-lg",
  },

  // Forms
  input:
    "w-full rounded-lg border border-gray-700 bg-gray-900 px-4 py-2.5 text-white placeholder-gray-500 focus:border-primary focus:ring-2 focus:ring-primary focus:ring-opacity-20 transition-all duration-300",
  label: "block text-sm font-medium text-gray-300 mb-1.5",
  formGroup: "mb-4 md:mb-6",
  formError: "mt-1.5 text-sm text-red-400",

  // Cards
  card: "bg-gray-900 rounded-2xl shadow-light border border-gray-800 transition-all duration-300",
  cardHover: "hover:shadow-light-lg hover:-translate-y-0.5",

  // Navigation
  navItem:
    "flex items-center justify-center text-gray-400 hover:text-primary transition-colors duration-300",
  navItemActive: "text-primary",

  // Badges
  badge:
    "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
  badgePrimary: "bg-primary-900 text-primary-200",
  badgeSuccess: "bg-green-900 text-green-200",
  badgeWarning: "bg-yellow-900 text-yellow-200",
  badgeDanger: "bg-red-900 text-red-200",
  badgeInfo: "bg-blue-900 text-blue-200",

  // Alerts
  alert: "rounded-lg p-4 mb-4",
  alertSuccess: "bg-green-900 text-green-200 border border-green-800",
  alertError: "bg-red-900 text-red-200 border border-red-800",
  alertWarning: "bg-yellow-900 text-yellow-200 border border-yellow-800",
  alertInfo: "bg-blue-900 text-blue-200 border border-blue-800",

  // Tables
  table: "min-w-full divide-y divide-gray-800",
  tableHead: "bg-gray-900",
  tableHeadCell:
    "px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider",
  tableBody: "bg-black divide-y divide-gray-800",
  tableCell: "px-4 md:px-6 py-4 text-sm text-gray-300",
  tableRowHover: "hover:bg-gray-900",

  // Loading
  loadingSpinner:
    "animate-spin rounded-full h-6 w-6 border-2 border-primary border-t-transparent",

  // Transitions
  transition: "transition-all duration-300",
  transitionSlow: "transition-all duration-500",
  transitionFast: "transition-all duration-150",

  // Borders
  border: "border border-gray-800",
  borderLight: "border border-gray-900",
  borderPrimary: "border border-primary",

  // Shadows
  shadow: "shadow-light",
  shadowMd: "shadow-light-md",
  shadowLg: "shadow-light-lg",

  // Spacing
  spacing: {
    xs: "p-1",
    sm: "p-2",
    md: "p-4",
    lg: "p-6",
    xl: "p-8",
  },

  // Grid
  grid: "grid grid-cols-1 gap-4 md:gap-6",
  grid2: "grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6",
  grid3: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6",
  grid4: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6",
};

export type GlobalStyle = typeof globalStyle;
export default globalStyle;
